import styled from '@emotion/styled';
import { Switch } from '@mui/material';

export const HPSwitch = styled(Switch)(({}) => ({
  padding: 8,
  width: 62,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    backgroundColor: '#6C6D6E',
    opacity: 1,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.75rem',
      fontWeight: 500,
      transition: 'opacity 0.3s ease-in-out',
    },
    '&::before': {
      left: '0.8125rem',
      content: "'ON'",
      color: '#fff',
      fontSize: '0.625rem',
      opacity: 0,
    },
    '&::after': {
      color: '#fff',
      right: '0.8125rem',
      content: "'OFF'",
      fontSize: '.5625rem',
      opacity: 1,
    },
  },
  '& .Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#05b212 !important',

    '&::before': {
      opacity: 1, // Show "OFF" text when switch is off
    },
    '&::after': {
      backgroundColor: '#6C6D6E !important',
      opacity: 0, // Hide "ON" text when switch is off
    },
  },
  '& .Mui-checked': {
    transform: 'translateX(23px)',
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: '1rem',
    height: '1rem',
    margin: '0.125rem',
    color: '#fff',
  },
}));
